import logo from "@/public/cuologo.png";

/** Full-screen bootstrap loader for auth/permission gates and the root route fallback. */
export default function FullPageLoader() {
  return (
    <div
      role="status"
      aria-label="Loading"
      className="fixed inset-0 flex items-center justify-center bg-background"
    >
      <img src={logo} alt="" className="w-40 animate-logo-breathe select-none" draggable={false} />
    </div>
  );
}
